import { Container } from "react-bootstrap";

const PrivacyPolicy = () => {
  return (
    <>
      <section className="common-area">
        <Container>
          <div className="term-condition-area">
            <h4 className="title">PRIVACY POLICY</h4>
            <p>
              <b>
                Your privacy is important to us. We strive to ensure that our
                use of your personal information or personal data is lawful,
                reasonable, and relevant to our business activities, with the
                goal of improving our services and your experience.
              </b>
            </p>
            <p>
              PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE
              SERVICES.
            </p>
            <p>
              Document Control
              <br></br> Updated on December 23, 2024
            </p>
            <h6 className="sub-to-sub-title">1. Aim and Scope of Policy</h6>
            <p>
              This privacy notice sets out what personal information we collect
              from you when you use our platform (which could be our online
              platform, mobile site, an application or any other electronic
              platform), how we collect your personal information, why we
              collect it and how we use it, and related matters.
            </p>
            <p>
              Please read this privacy notice carefully to understand our views
              and practices regarding your personal information and how we will
              treat it (even if you're a long-standing site user) and contact us
              if you need any clarity or assistance, using the contact details
              set out at the end of this policy.
            </p>
            <p>
              This privacy notice is applicable to Union Boda. This privacy
              notice should be read in conjunction with the standard terms and
              conditions of use of Union App or other KaCyber systems and must
              be applied with due consideration and compliance with Uganda’s
              Data Protection and Privacy Act (2019).
            </p>
            <p>
              This policy applies to the processing of personal data in manual
              and electronic records kept by the Company. It also covers the
              Company’s response to any data breach and other rights under the
              Data Protection and Privacy Act (2019), and it is also in line
              with the Company Information Security Policy: the document
              approved by KaCyber’s Board of Directors and Senior management,
              which includes its commitment to guaranteeing the security of the
              information and establishes the measures and controls that the
              company will adopt to ensure the confidentiality, integrity,
              availability, and privacy of the information.
            </p>
            <p>
              “Personal data” is information that relates to an identifiable
              person who can be directly or indirectly identified from that
              information, for example, a person’s name, identification number,
              location, online identifier.
            </p>
            <p>
              “Special categories of personal data” is data, which relates to
              the religious or philosophical beliefs, political opinion, sexual
              life, financial information, health status or medical records of
              an individual.
            </p>
            <p>
              ‘Personal identifiable information’ is information that can be
              used uniquely to identify you, such as your name, mailing address,
              email address, telephone numbers and credit card number. In order
              to provide you with service, we may require that you provide us
              with personal identifiable information.
            </p>
            <p>
              “Data processing” is any operation or set of operations which is
              performed on personal data or on sets of personal data, whether or
              not by automated means, such as collection, recording,
              organization, structuring, storage, adaptation or alteration,
              retrieval, consultation, use, disclosure by transmission,
              dissemination or otherwise making available, alignment or
              combination, restriction, erasure or destruction.
            </p>
            <p>
              KaCyber makes a commitment to ensuring that personal data,
              including special categories of personal data is processed in
              compliance with the Data Protection and Privacy Act (2019) and all
              its employees conduct themselves in line with this, and other
              related policies. Where third parties process personal data on
              behalf of the Company, the Company will ensure that the third
              party takes such measures in order to maintain the Company’s
              commitment to protecting personal data. In line with the Data
              Protection and Privacy Act (2019), the Company understands that it
              will be accountable for the processing, management and storage and
              retention of all personal data held in the form of manual records
              and on information systems.
            </p>
            <p>
              Please read this Privacy Policy carefully and ensure that you
              understand it. By using our site and, or our application, you give
              your affirmative consent that you have read and accepted all the
              terms in this Privacy Policy. If you do not accept and agree with
              this Privacy Policy, you must stop using Our Site/application
              immediately.
            </p>
            <h6 className="sub-to-sub-title">
              1. Definitions and Interpretation
            </h6>
            <p>
              In this Policy the following terms shall have the following
              meanings:
            </p>
            <p>
              <b> “Account”</b>means an account required to access and/or use
              certain areas and features of Our Site or application;
            </p>
            <p>
              <b>“Cookie”</b>means a small text file placed on your computer or
              device by Our Site when you visit certain parts of Our Site and/or
              when you use certain features of Our Site. Details of the Cookies
              used by Our Site are set out in Part 13, below; and
            </p>
            <p>
              <b>“Driver ”</b>means an independent business person operating as
              a vehicle/ as a two-wheel transportation provider for people or
              goods. This term shall be used to mean either a “Union App Driver”
              or “Union App Rider” interchangeably as the context may require
              and defined in the Driver Terms of Use
            </p>
            <p>
              <b>“Owner”</b>means those who make their vehicle(s) available for
              others to use through our application.
            </p>
            <p>
              <b>“Customer”</b>means a user or consumer of any Union Apps and/or
              a beneficiary to Services extended through Our Application
            </p>
            <p>
              <b>“Site ”</b>means our website www.unionmobilityapp.com and/or
              the Union Apps /mobile application downloadable from the App
              store, Huawei App Gallery or Google Play store or from our
              website.
            </p>
            <h6 className="sub-to-sub-title">2. Information About Us</h6>
            <p>
              Our Site and application is operated by National Boda Boda Riders
              Union
              Cooperative,............................................................................and
              ……………………………………………………… a l The registered address of the Boda union
              is ………………………………………………………. KaCyber Security Technologies Limited,
              ………………………………………………………… is registered at Plot 19-21 National ICT
              Innovation Hub, Nakawa - Kampala and is the technical systems
              provider and data controller of the Union Application and
              websites. Data Protection Email address:{" "}
              <a href="mailto:support@unionmobilityapp.com">
                support@unionmobilityapp.com
              </a>
              Helpline Telephone number:
              <a href="tel:+256800280025">+256800280025</a>
            </p>
            <h6 className="sub-to-sub-title">
              ‍3. What Does This Policy Cover?
            </h6>
            <p>
              This Privacy Policy applies to your use of our Site and our mobile
              applications. Please note that we have no control over how your
              data is collected, stored, or used by other websites whose links
              may be provided on our website and we advise you to check the
              privacy policies of any such websites before providing any data to
              them.
            </p>
            <h6 className="sub-to-sub-title">‍4. What is Personal Data?</h6>
            <p>
              Personal data is defined as any information relating to an
              identified or identifiable natural person.
            </p>
            <h6 className="sub-to-sub-title">‍5. What Are Your Rights?</h6>
            <p>
              As a data subject, you have the following rights, which we will
              always work to uphold:
            </p>
            <ul className="under-list">
              <li>
                The right to be informed about our collection and use of your
                personal data. This Privacy Policy should tell you everything
                you need to know, but you can always contact us to find out more
                or to ask any questions using the details in Part 14.
              </li>
              <li>
                The right to access the personal data we hold about you. Part 12
                will tell you how to do this.
              </li>
              <li>
                The right to have your personal data rectified if any of your
                personal data held by us is inaccurate or incomplete. Please
                contact us using the details in Part 14 to find out more.
              </li>
              <li>
                The right to be forgotten, i.e., the right to ask us to delete
                or otherwise dispose of any of your personal data that we have.
                Please contact us using the details in Part 14 to find out more.
              </li>
              <li>
                The right to restrict (i.e., prevent) the processing of your
                personal data.
              </li>
              <li>
                The right to object to us using your personal data for a
                particular purpose(s).
              </li>
              <li>
                The right to data portability. This means that, if you have
                provided personal data to us directly, we are using it with your
                consent or for the performance of a contract, and that data is
                processed using automated means, you can ask us for a copy of
                that personal data to re-use with another service or business in
                many cases.
              </li>
            </ul>
            <p>
              For more information about our use of your personal data or
              exercising your rights as outlined above, please contact us using
              the details provided in Part 14.
            </p>
            <p>
              Further information about your rights can also be obtained from
              the Personal Data Protection Office. If you have any cause for
              complaint about our use of your personal data, you have the right
              to lodge a complaint with the Personal Data Protection Office.
            </p>
            <h6 className="sub-to-sub-title">
              6. What Data Do We Collect?(For The Drivers)
            </h6>
            <p>
              Depending upon your use of our Site and, or application, we may
              collect some or all of the following personal and non-personal
              data including but not limited to;-
            </p>
            <ul className="bullet-order">
              <li>Full names</li>
              <li>Photo</li>
              <li>Next of Kin Phone Number</li>
              <li>Date of birth</li>
              <li>Gender</li>
              <li>Location/Address</li>
              <li>Email address</li>
              <li>Telephone number</li>
              <li>Identification Document</li>
              <li>Driving Permit</li>
              <li>Payment information</li>
              <li>Information about your preferences and interests</li>
              <li>IP address</li>
              <li>Web browser type and version</li>
              <li>Operating system</li>
            </ul>
            <p>We use the information you give to;</p>
            <ol className="under-list">
              <li>Identify you</li>
              <li>Locate you</li>
              <li>Pair you with a rider</li>
              <li>
                Link you to an approved payment system (Union wallet powered by
                KaCyber)
              </li>
              <li>Improve the service such as saving common destinations</li>
              <li>
                Connect services like “Send” and “Share” with your contacts
              </li>
              <li>For product research development</li>
              <li>To provide measurements and analytics</li>
              <li>
                Communicate with you (share marketing communications on our
                products)
              </li>
              <li>Generally, improve your user experience</li>
              <li>For Legal and Compliance purposes with the law</li>
            </ol>
            <h6 className="sub-to-sub-title">
              7. How Do We Use Your Personal Data?
            </h6>
            <p>
              Further to clause 6, we use your data for the necessary
              performance of a contract with you and because you have consented
              to the use of your personal data, or because it is in our
              legitimate business interests to use it. Your personal data may
              also be used for the following purposes:
            </p>
            <ul className="bullet-order">
              <li>Providing and managing your Account;</li>
              <li>Photo</li>
              <li>
                Providing and managing your access to Our Site and, or
                application;
              </li>
              <li>
                Personalising and tailoring your experience on Our Site and, or
                application;
              </li>
              <li>
                Supplying our services to you. Your personal details are
                required in order for us to enter into a contract with you.
              </li>
              <li>Personalising and tailoring our services for you.</li>
              <li>
                Communicating with you. This may include responding to emails or
                calls from you.
              </li>
              <li>
                Supplying you with information that you have the option to
                opt-out at any time.
              </li>
              <li>
                For purposes of “Know Your Customer” or Customer Due Diligence
                under the law.
              </li>
            </ul>
            <p>
              We may also use your personal data for marketing purposes, which
              may include contacting you by email, telephone, text message or
              any other means, with information, news, and offers on our
              services. You will not be sent any unlawful marketing or spam. We
              will always work to fully protect your rights and comply with our
              obligations under the law, and you will always have the
              opportunity to opt-out.
            </p>
            <p>
              Third Parties whose content appears on Our Site may use
              third-party Cookies, as detailed below in Part 13. Please refer to
              Part 13 for more information on controlling cookies. Please note
              that we do not control the activities of such third parties, nor
              the data that they collect and use themselves, and we advise you
              to check the privacy policies of any such third parties.
            </p>
            <h6 className="sub-to-sub-title">
              8. How Long Will You Keep My Personal Data?
            </h6>
            <p>
              {" "}
              We store data until it is no longer necessary to provide our
              services or until your account is deleted - whichever comes first.
              This is a case-by-case determination that depends on things like
              the nature of the data, why it is collected and processed, and
              relevant legal or operational retention needs in accordance with
              the law.
            </p>
            <h6 className="sub-to-sub-title">
              9. How and Where Do You Store or Transfer My Personal Data?
            </h6>
            <p>
              We will only store or transfer your personal data to countries
              that have adequate data protection standards/laws or where you
              have consented to the processing or storing of personal data
              outside Uganda. We may in certain instances such as for analytics
              purposes or for the reasons in 6 and 7 above share your data with
              external third parties, that may be based out of your
              jurisdiction. In any such case, we shall ensure any such data is
              transferred securely and following best practice in your
              jurisdiction.
            </p>
            <p>
              Data at UnionApp is stored in renown and secure servers. Data from
              the UnionApp applications is stored in Amazon Web Services (AWS)
              and Google Cloud (GCP). UnionApp uses MySQL and Amazon Relational
              Database Service (RDS) as the database engine and all access to
              the database are confidential and protected with reasonable
              security features.
            </p>
            <h6 className="sub-to-sub-title">
              10. Do You Share My Personal Data?
            </h6>
            <p>
              The UnionApp may use data processors outside of Uganda. Such data
              processors shall be located in countries that have laws similar to
              Uganda’s Data Protection and Privacy Act. We may share your
              personal data with processors and other companies in our group and
              this may include subsidiaries, a holding company or any other
              entity that is a party to a merger and/or acquisition of an
              interest in UnionApp. We may sometimes contract with the following
              data processors to supply certain services. These may include
              payment processing, delivery, and marketing. In some cases, those
              parties may require access to some or all of your personal data
              that we hold.
            </p>
            <ul className="bullet-order">
              <li>
                Google Firebase based in the USA – the purpose for this is to
                process information about how customers use the UnionApp
                application and optimize user experience; data processing that
                helps with data optimization and marketing purposes; data
                processing that helps to process customer communications Please
                find firebase’s privacy policy Privacy and Security in Firebase
              </li>
              <li>
                Africastalking, a data processor that supports authentication
                and notification services for our application. Please find
                africastalking’s privacy policy Privacy policy | Africa’s
                Talking
              </li>
            </ul>
            <p>
              If any of your personal data is required by a processor, as
              described above, we will take steps to ensure that your personal
              data is handled safely, securely, and in accordance with your
              rights, our obligations, and the third party’s obligations under
              the law. Without prejudice, you are advised to read the privacy
              policies of any processors we may contract.
            </p>
            <p>
              By using the UnionApp site/application, You (the User) give to Us
              (UnionApp) your consent to collect, use and process your data for
              the purposes and in the manner indicated herein and in the driver
              or passenger terms of use.
            </p>
            <h6 className="sub-to-sub-title">
              11. How Can I Control My Personal Data?
            </h6>
            <p>
              We provide you with the ability to access, rectify, port and erase
              your data. To learn more, call our helpline to be supported on any
              of the requests you may have.
            </p>
            <h6 className="sub-to-sub-title">
              12. How Can I Access My Personal Data?
            </h6>
            <p>
              If you want to know what personal data we have about you, you can
              ask us for details of that personal data and for a copy of it
              (where any such personal data is held). This is known as a
              “subject access request”. All subject access requests should be
              made in writing and sent to the email or postal addresses shown in
              Part 14. We will respond to your subject access request within the
              timelines provided under the law. Normally, we aim to provide a
              complete response, including a copy of your personal data within
              that time. In some cases, however, particularly if your request is
              more complex, more time may be required as communicated by our
              team from time to time from the date we receive your request. You
              will be kept fully informed of our progress.
            </p>
            <h6 className="sub-to-sub-title">13. How Do You Use Cookies?</h6>
            <p>
              Our Site may place and access certain first-party Cookies on your
              computer or device. First-party Cookies are those placed directly
              by us and are used only by us. We use Cookies to facilitate and
              improve your experience of our Site and to provide and improve our
              services. We have carefully chosen these Cookies and have taken
              steps to ensure that your privacy and personal data is protected
              and respected at all times. Please see our cookie policy here
              ……………………………………………………………………….
            </p>
            <h6 className="sub-to-sub-title">14. How Do I Contact You?</h6>
            <p>
              If you have any questions about this policy, you can contact us as
              described below.
            </p>
            <ul>
              <li>
                Email:{" "}
                <a href="mailto:support@unionmobilityapp.com">
                  support@unionmobilityapp.com
                </a>
              </li>
              <li>
                Telephone: <a href="tel:+256800280025">+256800280025</a>
              </li>
              <li>
                Social Media:
                <a href="" target="_blank">
                  Instagram
                </a>{" "}
                /
                <a href="" target="_blank">
                  Facebook
                </a>{" "}
                /
                <a href="" target="_blank">
                  TikTok
                </a>{" "}
                /
                <a href="" target="_blank">
                  Twitter
                </a>{" "}
                /
                <a href="" target="_blank">
                  X
                </a>
              </li>
            </ul>
            <h6 className="sub-to-sub-title">
              15. Changes to this Privacy Policy
            </h6>
            <p>
              We may change this Privacy Policy from time to time and in some
              instances without notice to you. This may be necessary, for
              example, if the law changes, or we change our business in a way
              that affects personal data protection. Any changes will be
              immediately posted on our Site and, or application and you will be
              deemed to have accepted the terms of the Privacy Policy on your
              first use of our Site and, or application following the
              alterations. We recommend that you check this page regularly to
              keep up-to-date. By your use of our Site and, or application, you,
              by affirmative action, consent to these terms. Please do not use
              our Site and, or application or services if you do not consent to
              these terms.
            </p>
          </div>
        </Container>
      </section>
    </>
  );
};
export default PrivacyPolicy;
